import { Fragment } from "react";
import { cn } from "@/lib/cn";
import { hotkeyLabel } from "@/lib/hooks";

/** Keyboard key cap. `<Kbd>K</Kbd>` or `<Kbd combo="mod+k" />` (platform-aware ⌘ / Ctrl). */
export function Kbd({ children, combo, className }: { children?: React.ReactNode; combo?: string; className?: string }) {
  const cap = "inline-flex h-5 min-w-5 items-center justify-center rounded-[5px] border border-line-strong bg-surface px-1 font-sans text-2xs font-bold text-fg-muted shadow-[0_1px_0_var(--ui-line-strong)]";
  if (combo) {
    return (
      <span className={cn("inline-flex items-center gap-0.5", className)}>
        {hotkeyLabel(combo).map((k, i) =>
          k === "then" ? (
            <span key={i} className="px-0.5 text-2xs text-fg-subtle">
              then
            </span>
          ) : (
            <Fragment key={i}>
              <kbd className={cap}>{k}</kbd>
            </Fragment>
          ),
        )}
      </span>
    );
  }
  return <kbd className={cn(cap, className)}>{children}</kbd>;
}
